<div class="lms-app-container" *ngIf="showUI">
  <p-progressBar *ngIf="loadProgressBar" mode="indeterminate"></p-progressBar>
  <app-lms-header></app-lms-header>
  <app-lms-nav-bar></app-lms-nav-bar>
  <app-lms-breadcrumb></app-lms-breadcrumb>
  <router-outlet></router-outlet>
  <app-lms-footer [copyrightMsg]="copyrightMsg"></app-lms-footer>
</div>
<div id="spinner-container" class="spinner-overlay" *ngIf="loadSpinner">
  <img class="spinner" src="../assets/icons/spinner.svg" alt="loading..." />
</div>
<app-toast-message></app-toast-message>
